<template>
    <div class="container reveal" >

        <div class="text-container">
            <div style="background-color: #f3eaeb" class="text-center font-weight-bold">
<!--                &lt;!&ndash;            <div class="py-15"></div>&ndash;&gt;style="background-color: #f3eaeb"-->
                <v-card elevation="0" class="mx-10 hidden-lg-and-up" style="border-radius: 15px;outline: 0px solid #ecced0;background-color: #f3eaeb">
                    <div style="letter-spacing: -2px; font-size: 30px; color: black; margin-top: -60px"
                         class="">
                        <div class="py-5"></div>
                        내 잠재력을 깨워줄 <br/><span style=" color: #A20916;text-decoration: underline #A20916 dashed;">스마트 유학 과외</span>를 만나보세요
                    </div>
                    <!--                            <div class="py-3"></div>-->

                    <!--                <div class="py-6"></div>-->
                    <!--                <div class="py-10"></div>-->

                </v-card>
                <v-card elevation="0" class="mx-10 hidden-md-and-down" style="border-radius: 15px;outline: 0px solid #ecced0;background-color: #f3eaeb; ">
                    <div style="letter-spacing: -2px; font-size: 34px; color: black; margin-top: -60px"
                         class="">

                        <div class="py-5"></div>
                        내 잠재력을 깨워줄 <br/><span style=" color: #A20916;text-decoration: underline #A20916 dashed;">스마트 유학 과외</span>를 만나보세요
                        <div class="py-2"></div>
                    </div>
                    <!--                            <div class="py-3"></div>-->

                    <!--                <div class="py-6"></div>-->
                    <!--                <div class="py-10"></div>-->

                </v-card>


            </div>

        </div>
    </div>

</template>

<script>
    export default {
        name: "Potential",
        mounted() {
            window.addEventListener("scroll", this.reveal);
        },
        destroyed() {
            window.removeEventListener("scroll", this.reveal);
        },
        methods: {
            reveal() {
                var reveals = document.querySelectorAll(".reveal");

                for (var i = 0; i < reveals.length; i++) {
                    var windowHeight = window.innerHeight;
                    var elementTop = reveals[i].getBoundingClientRect().top;
                    var elementVisible = 150;

                    if (elementTop < windowHeight - elementVisible) {
                        reveals[i].classList.add("active");
                    } else {
                        reveals[i].classList.remove("active");
                    }
                }
            },
        },
    };
</script>

<style>


    body {
        /*background: #42455a;*/
    }

    section {
        /*min-height: 100vh;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
    }

    .each-title {
        font-size: 21px !important;
        text-align: left !important;
    }

    section:nth-child(1) {
        color: black;
    }

    section:nth-child(2) {
        color: black;
        background: #ffffff !important;
    }

    /* Add more styles for other sections as needed */
    section .container {
        /*margin: 100px;*/
        background-color: #ffffff !important;

    }

    section h1 {
        /*font-size: 3rem;*/
        /*margin: 20px;*/
    }

    section h2 {
        font-size: 40px;
        /*text-align: center;*/
        text-transform: uppercase;
    }

    section .text-container {
        display: flex;
        padding: 20px;
        margin-top: 10px;
    }

    section .text-container .text-box {
        /*margin: 20px;*/
        /*padding: 20px;*/
        /*background: #00c2cb;*/

    }

    section .text-container .text-box h3 {
        font-size: 30px;
        /*text-align: center;*/
        text-transform: uppercase;
        margin-bottom: 10px;
    }

    @media (max-width: 900px) {
        section h1 {
            font-size: 2rem;
            /*text-align: center;*/
        }

        section .text-container {
            flex-direction: column;
        }
    }

    .reveal {
        position: relative;
        transform: translateY(150px);
        opacity: 0;
        transition: 1s all ease;
    }

    .reveal.active {
        transform: translateY(0);
        opacity: 1;
    }
</style>

